import base from './base';

export default {
  ...base,
  common: {
    ...base.common,
    en: 'EN',
    sp: 'SP'
  },
  footer: {
    address: {
      one: 'Business Address',
      two: 'telefono / Fax',
      three: 'Online',
      onedetails: '1221 E. Dyer Rd #250 Santa Ana, CA 92705',
      twodetails: ' 1-800-601-4511',
      threedetails: 'support@eld-pro.com'
    },
    patent: 'Patent pending',
    copyright: '2020 ELD Mandate Pro All Rights Reserved',
    PrivacyLegal: 'Privacy Policy'
  }
};
